import { IGiftActions } from '../../../model';

/**
 * Returns bool whether a gifts list should be shown
 * @param gifts
 */
export const shouldExpandCampaignsInCart = (gifts: IGiftActions[]): boolean =>
  gifts.some((c) => c.expandInCart || c.assignGiftList.some((gift) => gift.selected));
